import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import { authAPI } from '../lib/api';
import { setSession } from '../lib/auth';
import { t } from '../lib/i18n';
import { errorText } from '../lib/authErrors';

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { data } = await authAPI.login(username.trim(), password);
      setSession(data.token, { name: data.name, role: data.role, mid: data.mid || '', lr: data.lr || null });
      navigate('/', { replace: true });
    } catch (err) {
      // Desde el login DIRECTO del LMS no se desvía a ningún lado: cualquier
      // acceso denegado (sin permiso, o mentoría sin aprobar) se queda aquí con
      // el mismo mensaje. El desvío a Mi Cuenta es cosa del SSO (SsoLanding).
      if (err?.response?.status === 403) setError(t('No access to this tool'));
      else setError(errorText(err, t('Login failed')));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <Brand size="lg" className="justify-center" />
          <div className="mt-2 text-sm text-lms-muted">{t('Learning Management System')}</div>
        </div>
        <form
          onSubmit={submit}
          className="rounded-lg border border-lms-border bg-lms-surface p-6 space-y-4 shadow-[var(--lms-elev-2)]"
        >
          <div>
            <label htmlFor="lms-user" className="block text-sm text-lms-muted mb-1.5">
              {t('Username or email')}
            </label>
            <input
              id="lms-user"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
              className="w-full rounded-md border border-lms-border bg-lms-input px-3 py-2 text-sm outline-none focus:border-[var(--lms-focus-border)]"
            />
          </div>
          <div>
            <label htmlFor="lms-pass" className="block text-sm text-lms-muted mb-1.5">
              {t('Password')}
            </label>
            <input
              id="lms-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full rounded-md border border-lms-border bg-lms-input px-3 py-2 text-sm outline-none focus:border-[var(--lms-focus-border)]"
            />
          </div>
          {error && (
            <p role="alert" className="text-sm" style={{ color: 'var(--lms-danger)' }}>
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-md bg-lms-accent px-3 py-2 text-sm font-semibold text-lms-accent-ink disabled:opacity-60"
          >
            {busy ? t('Signing in…') : t('Sign in')}
          </button>
        </form>
      </div>
    </div>
  );
}
